import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_wrkrs_undstand_the_info_included_win_their_written_terms_and'

export const dataPointDefinition = {
  retracedId: 'do_wrkrs_undstand_the_info_included_win_their_written_terms_and',
  name: 'Do workers understand the information included within their written terms and conditions documents?',
  description:
    'The intent of this question is to understand if workers actually understand the provisions or "information" that is included within their written terms and conditions documents. \r\r\n\r\r\nFor example, if workers receive a copy of their employment terms and conditions document, but cannot understand the language of the document or don\'t really understand the terms, meaning or acronyms within the document, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-3--6',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6140,
  sectionId: '2.2.4',
  impactArea: 'Contracts and HR',
  impactAreaId: 'CONTRACTS_AND_TERMS_OF_EMPLOYMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
